module.exports = __webpack_public_path__ + "fonts/PlayfairDisplay-Bold.8c44fea.woff";